import React from "react";
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import EduDoc from "../../assets/pdf/Education_Payments_Solution_by_Safexpay.pdf";
import GovDoc from "../../assets/pdf/Government_Payment_Solution_by_Safexpay.pdf";

const MainNav = () => {
  return (
    <>
      <Nav className="ml-auto" navbar>
        <NavLink href="/">Home</NavLink>
        <UncontrolledDropdown className="dv-product-nav">
          <DropdownToggle nav caret>
            Product
          </DropdownToggle>
          <DropdownMenu right className="dv-product-nav-child">
            <div className="">
              <div className="dv-menu">
                <div className="menu-heding">
                  <img
                    alt="safexpay-img"
                    src={require("assets/img/icons/business.png")}
                    className="img-menu sp-img"
                  />
                </div>
                <div className="menu-items">
                  <h5 className="menu-heading">For Business</h5>
                  <NavLink href="/business/accept-payments">
                    Accept Payments
                  </NavLink>
                  <NavLink href="/business/make-payouts">Make Payouts</NavLink>
                  <NavLink href="/business/digital-banking">Neo Bank</NavLink>
                </div>
              </div>

              <div className="dv-menu">
                <div className="menu-heding">
                  <img
                    alt="safexpay-img"
                    src={require("assets/img/icons/white-label.png")}
                    className="img-menu ng-mglt sp-img"
                  />
                </div>
                <div className="menu-items">
                  <h5 className="menu-heading">White Label Platform</h5>
                  <NavLink href="/white-label/payments-platform">
                    Payments Platform
                  </NavLink>
                  <NavLink href="/business/digital-banking#Platform">
                    Payouts
                  </NavLink>
                </div>
              </div>
              <div className="dv-menu dv-whitelabel">
                <div className="menu-heding">
                  <img
                    alt="safexpay-img"
                    src={require("assets/img/icons/white-label.png")}
                    className="img-menu ng-mglt sp-img"
                  />
                </div>
                <div className="menu-items">
                  <h5 className="menu-heading">Sector Specific Solutions</h5>
                  <NavLink href={EduDoc} target="_blank">
                    Education Payments Solution
                  </NavLink>
                  <NavLink href={GovDoc} target="_blank">
                    Government Payments Solution
                  </NavLink>
                </div>
              </div>

              <div className="dv-menu">
                <div className="menu-heding">
                  <img
                    alt="safexpay-img"
                    src={require("assets/img/icons/partner.png")}
                    className="img-menu sp-img ng-mglt"
                  />
                </div>
                <div className="menu-items">
                  <h5 className="menu-heading">Partner Program</h5>
                  <NavLink href="/partner/reseller">Reseller</NavLink>
                </div>
              </div>
            </div>
          </DropdownMenu>
        </UncontrolledDropdown>

        <NavItem>
          <NavLink href="/pricing">Pricing</NavLink>
        </NavItem>
        <UncontrolledDropdown className="dv-company-nav">
          <DropdownToggle nav caret>
            Company
          </DropdownToggle>
          <DropdownMenu right className="dv-company-nav-child">
            <div className="d-md-flex">
              <div className="dv-menu">
                <div className="menu-heding">
                  <img
                    alt="safexpay-img"
                    src={require("assets/img/icons/company.png")}
                    className="img-menu sp-img ng-mglt"
                  />
                </div>
                <div className="menu-items">
                  <NavLink href="/company/about-us">About Us</NavLink>
                  <NavLink href="/career">Career</NavLink>
                  <NavLink href="/company/disclaimer">
                    Disclaimer
                  </NavLink>
                  <NavLink href="/company/terms-conditions">
                    Terms &amp; Conditions
                  </NavLink>
                </div>
              </div>
            </div>
          </DropdownMenu>
        </UncontrolledDropdown>
        <UncontrolledDropdown className="dv-company-nav">
          <DropdownToggle nav caret>
            Policies
          </DropdownToggle>
          <DropdownMenu right className="dv-company-nav-child">
            <div className="d-md-flex">
              <div className="dv-menu">
                <div className="menu-heding">
                  <img
                    alt="safexpay-img"
                    src={require("assets/img/icons/company.png")}
                    className="img-menu sp-img ng-mglt"
                  />
                </div>
                <div className="menu-items">
                  <NavLink href="/policies/privacy-policy">
                    Privacy Policy
                  </NavLink>
               
                  <NavLink href="/policies/risk-management">
                    Risk Management
                  </NavLink>
               
                  <NavLink href="/policies/customer-grievance-policy">
                    Customer Grievance
                  </NavLink>
                
                  <NavLink href="/policies/responsible-disclosure-policy">
                    Responsible Disclosure
                  </NavLink>
                
                  <NavLink href="/policies/regulatory-disclosures">
                    Regulatory Disclosures
                  </NavLink>
                </div>
              </div>
            </div>
          </DropdownMenu>
        </UncontrolledDropdown>
        <NavItem>
          <NavLink href="/support">Support</NavLink>
        </NavItem>
        <NavItem className="login-nav">
          <NavLink href="/register/payments-platform" className="btn-support-nav">
            Sign Up
          </NavLink>
          {/* <NavLink
                        onClick={() => this.openMaintenancePage()}
                        className="btn-support-nav"
                      >
                        Sign Up
                      </NavLink> */}
        </NavItem>
        <NavItem className="login-nav">
          <NavLink
            // href="https://avantgardepayments.com/agmerchant/paygateIndex.jsp"
            //href="/login"
            href="/login?app=shopify&domainURL=www"
            className="btn-support-nav"
          >
            Login
          </NavLink>
        </NavItem>
        {/* <NavItem className="support-nav">
                      <NavLink href="/support" className="btn-support">
                        Support
                      </NavLink>
                      ?name=shopify&domainURL=www
                    </NavItem> */}
      </Nav>
    </>
  );
};

export default MainNav;
